import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';
import { Logo } from 'src/components/logo';

// ----------------------------------------------------------------------

const FooterRoot = styled('footer')(({
  theme
}) => ({
  position: 'relative',
  backgroundColor: theme.vars.palette.background.paper
}));
export function FooterSimple(t0) {
  const $ = _c(19);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  const {
    t
  } = useTranslate();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      py: 5,
      textAlign: "center"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = [t1, ...t2];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Logo />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mt: 1,
      typography: "caption",
      gap: {
        xs: 1,
        md: 0.5
      },
      display: {
        xs: "grid",
        md: "flex"
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>© {new Date().getFullYear()} {CONFIG.appInvoice.name} v{CONFIG.appVersion}.</div>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("All rights reserved");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <Container>{t4}<Box sx={t5}>{t6}<div>{t7}</div></Box></Container>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== other || $[16] !== t3 || $[17] !== t8) {
    t9 = <FooterRoot sx={t3} {...other}>{t8}</FooterRoot>;
    $[15] = other;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}